import React from "react";
import { Link } from "react-router-dom";
import { HOTEL } from "@/lib/site";

export default function MapEmbed({ height = "420px" }) {
  return (
    <div className="relative w-full overflow-hidden rounded-md border border-stone/15" data-testid="map-embed">
      <iframe
        title="Regency Inn & Suites location map"
        src={HOTEL.mapEmbed}
        width="100%"
        height={height}
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      <a
        href={HOTEL.mapDirections}
        target="_blank"
        rel="noreferrer"
        data-testid="map-directions"
        className="absolute bottom-4 left-4 rounded-full bg-bone/95 backdrop-blur px-5 py-2.5 text-sm font-medium text-forest shadow-lg hover:bg-amber hover:text-bone transition-colors"
      >
        Get Directions →
      </a>
    </div>
  );
}
